import { struct } from 'io-ts/Decoder';

import { Id as StepId } from '../../../../../job/create/step/Id';
import { Id as JobId } from '../../../../../job/Id';

export const ParamWithoutJob = struct({
	stepId: StepId,
});

export const ParamWithJob = struct({
	jobId: JobId,
	stepId: StepId,
});
